import React, { useEffect, useState } from 'react'
import DashboardLayout from './DashboardLayout'
import { Col, Container, Row, Tab, Tabs } from 'react-bootstrap';
import EmailList from './Marketing/EmailList';
import SenderEmail from './Marketing/SenderEmail';
import EmailCampaignList from './Marketing/EmailCampaignList';
import EmailContaint from './Marketing/EmailContaint';


const MarketingPage = () => {

    return (
        <DashboardLayout>
            <div className="main-content">

                {/* ✅ Marketing Header */}
                <Container fluid className="mt-3 mb-2">
                    <Row className="align-items-center">
                        <Col>
                            <h3 className="mb-0">📢 Marketing</h3>
                            <small className="text-muted">
                                Manage email lists, campaigns, and sender accounts
                            </small>
                        </Col>
                    </Row>
                </Container>

                {/* ✅ Tabs Section */}
                <Container fluid className="mt-2">
                    <Tabs
                        defaultActiveKey="emailList"
                        id="marketing-tabs"
                        className="mb-3"
                        mountOnEnter
                        unmountOnExit
                    >

                        <Tab eventKey="emailList" title="Email List">
                            <EmailList />
                        </Tab>

                        <Tab eventKey="emailContent" title="Email Content">
                            <EmailContaint />
                        </Tab>

                        <Tab eventKey="mails" title="Mails">
                            <EmailCampaignList />
                        </Tab>

                        <Tab eventKey="senderEmails" title="Sender Emails">
                            <SenderEmail />
                        </Tab>

                    </Tabs>
                </Container>

            </div>
        </DashboardLayout>
    )
}

export default MarketingPage